import React from 'react';
import { FormattedMessage } from 'react-intl';
import Chevron from '@alltrails/shared/icons/Chevron';
import * as styles from './styles/styles.module.scss';

type ShowMoreCardProps = { url: string };

const ShowMoreCard = ({ url }: ShowMoreCardProps) => (
  <a href={url} className={styles.container}>
    <div className={styles.showMore}>
      <FormattedMessage defaultMessage="Show more" />
      <Chevron orientation="right" />
    </div>
  </a>
);

export default ShowMoreCard;
